import {VStack} from 'platform/foundation';

import {Section} from '@dms/shared';

import {GeneralInformation} from './components/GeneralInformation';
import {RmaRequestItems} from './components/RmaRequestItems';

interface OverviewProps {
  rmaRequestId: string;
}

export function Overview(props: OverviewProps) {
  return (
    <Section isFullHeight>
      <VStack spacing={4} height="100%">
        <GeneralInformation rmaRequestId={props.rmaRequestId} />
        <RmaRequestItems rmaRequestId={props.rmaRequestId} />
      </VStack>
    </Section>
  );
}
